import { Eyebrow, Reveal } from "../Reveal";
import { WHY } from "../../data/site";

export const WhyCando = () => (
  <section data-testid="why-cando-section" className="section-pad bg-warm2">
    <div className="container-cando">
      <Reveal>
        <Eyebrow>Why Cando</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="h2 mt-6 max-w-2xl text-charcoal">A Better Construction Experience.</h2>
      </Reveal>

      <div className="mt-16 grid gap-px overflow-hidden border border-charcoal/10 bg-charcoal/10 md:grid-cols-2 lg:grid-cols-3" data-testid="why-cando-grid">
        {WHY.map((w, i) => (
          <Reveal key={w.title} delay={(i % 3) * 0.08} className="bg-warm2">
            <div className="group h-full p-9 transition-colors duration-500 hover:bg-warm lg:p-11" data-testid={`why-item-${i}`}>
              <span className="font-heading text-[15px] font-bold tracking-[0.2em] text-bronze">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="h4 mt-5 text-charcoal">{w.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-mute">{w.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
